import React from 'react';

import mapDotStyles from '../mapDot/mapDot.module.css';
import styles from './knoopGebied.module.css';

type KnoopGebiedCardProps = {
  title?: string;
  subtitle?: string;
  list?: { key: string; value: number; color: string }[];
};

export default function KnoopGebiedCard({ title, subtitle, list }: KnoopGebiedCardProps) {
  if (!title || !list) {
    return null;
  }
  return (
    <div className={styles.knoopGebiedCardOverlay}>
      <div className={styles.knoopGebiedCard}>
        <h2 className={styles.knoopGebiedCardTitle}>{title}</h2>
        {subtitle && <p className={styles.knoopGebiedCardSubtitle}>{subtitle}</p>}
        <ul className={styles.knoopGebiedCardList}>
          {list.map((item, idx) => (
            <li className={styles.knoopGebiedCardListItem} key={idx}>
              <span>{item.key}</span>
              <span className={mapDotStyles.mapDotButton} style={{ padding: '10px 6px 6px', background: item.color }}>
                {item.value}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
